export enum Application {
  prisma = 'prisma',
  lensa = 'lensa',
}
